import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "user-info" }
const _hoisted_2 = {
  key: 0,
  class: "ml-5 d-flex flex-column justify-content-center"
}
const _hoisted_3 = { class: "ms-5 d-flex flex-column justify-content-center" }
const _hoisted_4 = { class: "modal-header justify-content-center pt-3" }
const _hoisted_5 = { class: "row mt-2 mr-3 ml-3 pl-5 v-theme--light" }
const _hoisted_6 = { class: "d-flex justify-content-end m-3" }

import NoticeMenu from '@/layout/components/topNavbar/NoticeMenu.vue';
import HelpButton from '@/components/HelpButton.vue';
import { useAuth } from '@/services/user/Auth0UserProvider';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import Api from '@/services/api/ApiServiceFabrick';
import { onMounted, ref, computed } from 'vue';
import i18n from '@/lang/i18n';
import SelectRoleChecker from '@/router/selectRoleChecker';
import { GDialog } from 'gitart-vue-dialog';


export default /*@__PURE__*/_defineComponent({
  __name: 'TopNavbar',
  props: {
    isHamburgerOpen: { type: Boolean },
    hideNoticeIcon: { type: Boolean }
  },
  emits: ["update:isHamburgerOpen"],
  setup(__props: any, { emit: __emit }) {

const { logout } = useAuth();
const { push } = useRouter();
const route = useRoute();
const operationOfficeName = ref('');
const email = ref('');
const showSelectRole = ref(false)
const reloadDialogState = ref(false);
const currentRoleId = ref(0);

const props = __props;
const emit = __emit;

const toggleSideBar = () => {
  emit('update:isHamburgerOpen', !props.isHamburgerOpen);
};


const redirectSelectRole = () => {
  push({ path: '/select_role'});
};

const logoutAndRedirect = () => {
  logout();
  push({ path: '/' });
};

const getSelfInfo = async () => {
  const [account, office] = await Promise.all([
    Api().getSelfAccount(),
    Api().getSelfOffice(),
    SelectRoleChecker.getSelfRoles(),
  ]);
  operationOfficeName.value = role.value?.organization_name ??
    office.operation_office_name ?? office.company_name;
  email.value = account.email ?? '';
  currentRoleId.value = role.value?.id ?? 0;

  const count = await SelectRoleChecker.getRoleCount();
  showSelectRole.value = count != 1;
};

const role = computed(() => {
  const role = localStorage.getItem(SelectRoleChecker.SELECTED_ROLE_KEY)
  if (role) return JSON.parse(role)
  return null;

})

const closeReloadDialog = () => {
  reloadDialogState.value = false;
  location.reload();
};

window.addEventListener('storage', (event) => {
  if (event.key !== SelectRoleChecker.SELECTED_ROLE_KEY) {
    return;
  }

  reloadDialogState.value = !event.newValue || currentRoleId.value !== JSON.parse(event.newValue).id
});

onMounted(() => {
  getSelfInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app_bar, { height: "48" }, {
      prepend: _withCtx(() => [
        _createElementVNode("div", {
          class: "hamburger-menu",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSideBar()))
        }, [
          _createVNode(_component_v_icon, {
            icon: "mdi-menu",
            size: "large"
          })
        ]),
        _createVNode(_component_router_link, { to: { path: '/' } }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createElementVNode("img", {
              src: "/img/icons/octlink-icon.png",
              class: "logo"
            }, null, -1)
          ]))]),
          _: 1
        })
      ]),
      append: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, _toDisplayString(operationOfficeName.value), 1),
          _createElementVNode("div", null, _toDisplayString(email.value), 1)
        ]),
        _createVNode(HelpButton, {
          pageName: _unref(route).name,
          class: "ml-5"
        }, null, 8, ["pageName"]),
        (!props.hideNoticeIcon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(NoticeMenu, {
                isHamburgerOpen: props.isHamburgerOpen
              }, null, 8, ["isHamburgerOpen"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_menu, null, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_icon, _mergeProps({
                size: "large",
                icon: "mdi-account-circle-outline"
              }, props), null, 16)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  (showSelectRole.value)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (redirectSelectRole()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.mainTemplate.selectRole')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list_item, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (logoutAndRedirect()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.mainTemplate.logoutBtn')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(GDialog), {
      modelValue: reloadDialogState.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((reloadDialogState).value = $event)),
      persistent: "true",
      "max-width": "30%",
      transition: "custom-from-bottom-transition"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.mainTemplate.reloadDialog.title')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(i18n).global.t('pages.mainTemplate.reloadDialog.message')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_btn, {
            class: "m-1 reset-btn",
            onClick: closeReloadDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.mainTemplate.reloadDialog.closeButton')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})